<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">话务管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">坐席数据统计</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <!-- 日期 -->
                <a-range-picker  :default-value="[moment(getCurrentData(), 'YYYY-MM-DD'), moment(getCurrentData(), 'YYYY-MM-DD')]" :locale="locale" @change="ondateChange" />
                <!-- 坐席 -->
                <a-select style="width: 130px;margin-left:12px" allowClear @change="userhandleChange" placeholder="坐席" :showArrow="show">
                    <a-select-option v-for="item in userlist" :key="item.aid" :value="item.aid">
                        {{item.name}}
                    </a-select-option>
                </a-select>

                <a-button @click="exportmodal" type="primary" icon="upload">导出</a-button>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table rowKey="aid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
    
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <span slot="per" slot-scope="text">
                        <!-- {{text}} -->
                        <span v-if="text!=0">
                            {{text | percent}}%
                        </span>
                        <span v-else>{{text}}</span>
                    </span>

                    <span slot="time" slot-scope="text">
                        {{text | minTime}}
                    </span>

                     <span slot="min" slot-scope="text">
                        {{text | secondTime}}
                    </span>

                    <!-- <div > -->
                        <audio style="height:32px" controls="controls" slot="video" slot-scope="text" :src="text"></audio>
                    <!-- </div> -->

                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>


        <!-- 导出数据 -->
        <a-modal
            title="导出数据"
            :visible="exportvisible"
            :confirm-loading="confirmLoading"
            @cancel="handleCancel"
            :footer="null"
            >
            <div class="import-text">
                <a-spin :spinning="spinning">
                    <div class="export-content" >
                        <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" style="width: 54px; height: 54px; margin-bottom: 12px;">
                            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Artboard-Copy-83"><circle id="Oval-12" fill="#33B028" cx="27" cy="27" r="27"></circle><polyline id="Path-9" stroke="#FFFFFF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" points="14 28.6835304 22.5324773 37 41 19"></polyline></g></g>
                        </svg> 
                        <h4>批量导出已完成</h4>
                        <!-- <p>线索导出已完成,导出数据量{{totalnum}}条，下载导出文件。</p> -->
                        <a class="export-btn" :href="exporturl" download>
                            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Icon-color-2"><rect id="矩形" x="0" y="0" width="20" height="20"></rect><circle id="椭圆形" fill="#4F7AFD" cx="10" cy="10" r="7"></circle><path d="M13.7874223,8.70748256 L10.6082602,6.24464133 C10.4561396,6.09636616 10.2413392,6 9.99995555,6 C9.75857185,6 9.54386039,6.09636616 9.39422917,6.24616557 L6.20991046,8.70570428 C6.08170594,8.83831359 6,9.0096218 6,9.19955966 C6,9.60729521 6.36647646,9.93788702 6.81821516,9.93788702 C6.82452759,9.93788702 6.8306622,9.93712489 6.83688572,9.93695553 L6.83688572,9.94161295 L8.66634397,9.94161295 L8.66634397,14 L11.3335671,14 L11.3335671,9.94161295 L13.1331525,9.94161295 L13.1331525,9.93568533 C13.1493336,9.93653213 13.1652481,9.93805638 13.1817848,9.93805638 C13.6336124,9.93805638 14,9.60737989 14,9.19955966 C14,9.0096218 13.9182052,8.83839827 13.7874223,8.70748256 Z" id="路径" fill="#FFFFFF" fill-rule="nonzero" transform="translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "></path><rect id="矩形" fill="#4F7AFD" x="8" y="7" width="4" height="1"></rect></g></g>
                            </svg>
                            <span>下载导出文件</span>
                        </a>
                    </div>
                </a-spin>
            </div>
        </a-modal>
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import moment from 'moment'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
const columns = [
    {title: 'ID',dataIndex: 'aid',key: 'aid',width:90,fixed: 'left'},
    {title: '坐席姓名',dataIndex: 'name',key: 'name',width:120,fixed: 'left'},
    {title: '分配线索',dataIndex: 'userxs_count',key: 'userxs_count',width:120},
    {title: '客户数',dataIndex: 'user_count',key: 'user_count',width:100},
    {title: '转换率',dataIndex: 'conversionrate',key: 'conversionrate',width:100,scopedSlots: { customRender: 'per' }},
    {title: '拨打次数',dataIndex: 'calldetail_count',key: 'calldetail_count',width:120},
    {title: '接通次',dataIndex: 'calldetail_valid_count',key: 'calldetail_valid_count',width:120},
    {title: '接通率',dataIndex: 'connectionrate',key: 'connectionrate',width:120,scopedSlots: { customRender: 'per' }},
    {title: '通话时长(时-分)',dataIndex: 'calldetail_duration',key: 'calldetail_duration',width:140,scopedSlots: { customRender: 'time' }},
     {title: '平均通话时长',dataIndex: 'calldetail_duration_average',key: 'calldetail_duration_average',width:140,scopedSlots: { customRender: 'min' }},
    {title: '支付数',dataIndex: 'order_ispay',key: 'order_ispay',width:120},
    {title: '发货数',dataIndex: 'order_issendgoods',key: 'order_issendgoods',width:120},
    {title: '签收数',dataIndex: 'order_issignfor',key: 'order_issignfor',width:120},
    {title: '签收率',dataIndex: 'order_issignforrate',key: 'order_issignforrate',width:120,scopedSlots: { customRender: 'per' }},
    {title: '激活数',dataIndex: 'goods_isactivation',key: 'goods_isactivation',width:120},
    {title: '激活率',dataIndex: 'goods_isactivationrate',key: 'goods_isactivationrate',width:120,scopedSlots: { customRender: 'per' }},
    
    // {title: '日期',dataIndex: 'fwdStartTime',key: 'fwdStartTime',scopedSlots: { customRender: 'date' },width:130,fixed: 'right'}
];
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      },
      percent(text){
          return parseInt(text*100)
      },
      secondTime(value){
           const hour = parseInt(value / 3600) < 10 ? '0' + parseInt(value / 3600) : parseInt(value / 3600)
            const min = parseInt(value % 3600 / 60) < 10 ? '0' + parseInt(value % 3600 / 60) : parseInt(value % 3600 / 60)
            const sec = parseInt(value % 3600 % 60) < 10 ? '0' + parseInt(value % 3600 % 60) : parseInt(value % 3600 % 60)
            return hour + ':' + min + ':' + sec

      },
       minTime(min) {
        let minTime = "";
        let h = Math.floor(min / 60);
        min -= h * 60;
        if (min == 0) {
          minTime = h ? "0" + h + ":00" : "";
        } else {
          if (min < 10) {
            min = "0" + min;
          }
          if (h < 10) {
            h = "0" + h;
          }
          minTime = (h ? h + ":" : "00:") + (min ? min + "" : "");
        }
        return minTime;
      }
    },
    data(){
        return{
            useroption:[{id:1,name:'坐席1'}],
            locale,
            show:true,

            columns,
            data:[],
            tablespinning:true,
            spinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            userlist:"",

            search:"",
            billsec_start:0,
            billsec_end:"",

            exportvisible:false,
            confirmLoading:false,
            exporturl:"",

            starttime:moment(moment().format('YYYY-MM-DD')+' 00:00:01').unix(),
            endtime:moment(moment().format('YYYY-MM-DD')+' 23:59:59').unix()
        }
    },
  
    mounted(){
        this.fetch()
        this.getuserlist()

 
    },
    methods:{
        moment,
        getCurrentData(){
            console.log(moment().format('YYYY-MM-DD'))
            // this.starttime=moment(new Date().toLocaleDateString()+' 00:00:01').unix()
            // this.endtime=moment(new Date().toLocaleDateString()+' 23:59:59').unix()
            return new Date().toLocaleDateString();
            
        },

        handleCancel(){
            this.exportvisible=false
        },
        // 导出
        exportmodal(){
            this.exportvisible=true
            this.spinning=true
            this.$axios.post("/api/datastatistics/seatstatisticsexportlink",{
                aid:this.search,
                starttime:this.starttime,
                endtime:this.endtime
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.spinning=false
                    // this.exportload=false
                    this.exporturl=res.data.data.url
                }
            })
        },

        // 坐席列表
        getuserlist(){
            this.$axios.post("/api/system/adminlist",{
                pagesize:50,
                iskf:1
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.userlist=res.data.data.data
                }else{
                   this.$message.error(res.data.msg);  
                }
            })
        },

        // 日期范围
        ondateChange(date,dateString){
       
            this.starttime=moment(dateString[0]+' 00:00:01').unix()
            this.endtime=moment(dateString[1]+' 23:59:59').unix()
            this.fetch()
        },
        // 选择坐席
        userhandleChange(value){
            this.search=value
            this.fetch()
        },

         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },
        // 通话时长
        totimeseek(){
            this.fetch()
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/datastatistics/seatstatistics',{
                pagesize: this.size,
                page:this.currentpage,
                aid:this.search,
                starttime:this.starttime,
                endtime:this.endtime
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{

                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/traffic/datalist.vue